import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";

@Component({
  selector: 'app-little-angel-hands',
  templateUrl: './little-angel-hands.component.html',
  styleUrls: ['./little-angel-hands.component.scss']
})
export class LittleAngelHandsComponent implements OnInit {
  public newDisCardModal : boolean = false;
  newCardGroupNo: any = "";
  constructor() { }

  ngOnInit() {
  }
  opendonate(event) {
    $('#organization-widget-7gw9998r button')[0].click()
  }
  newDiscountModal() {
    this.newDisCardModal = true;
    this.newCardGroupNo = window.localStorage.getItem("UserGroup")

  }
  CloseNewCardModal(){
    this.newDisCardModal = false;
  }
  PrintMe() {
    setTimeout(() => {
      window.print();

    }, 600);
  }
}